export const UPLOAD_DOCUMENT_MAX_FILES_FAILURE =
  'UPLOAD_DOCUMENT_MAX_FILES_FAILURE';
export const DELETE_FILE_REQUEST = 'DELETE_FILE_REQUEST';
export const DELETE_FILE_SUCCESS = 'DELETE_FILE_SUCCESS';
export const DELETE_FILE_FAILURE = 'DELETE_FILE_FAILURE';
export const INVALID_FILE_STATUS = 'invalid';
export const SUCCESS_STATUS = 'available';
export const LRS_DOCUMENT_TYPE = 'LRS';

export const NOT_FAILED_FILE_STATUSES = [
  'available',
  'pending',
  'doc_verify_in_progress',
  'doc_verify_with_errors',
];

export const DELETABLE_FILE_STATUSES = [
  'available',
  'doc_verify_with_errors',
  'invalid',
];
